<template>
  <p>Edit {{task.title}}</p>
</template>

<script>
export default {
  props: ['task']
}
</script>
